import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { LimitedTimeOfferGridBlock } from "../components/LimitedTimeOfferGridBlock";

type IProps = Immutable<templates.LimitedTimeOfferGridBlockTemplate>;

export const Template = (props: IProps): React.JSX.Element => {
    return <LimitedTimeOfferGridBlock value={props.value} />;
};
